import React from 'react';
import cn from 'classnames';
import { Visibility } from '../../../types/common-types';
import './style.scss';
import Dropdown from './img/dropdown.svg';
import CheckboxOn from './img/checkbox_on.svg';
import CheckboxOff from './img/checkbox_off.svg';
import RadioOn from './img/radio_on.svg';
import RadioOff from './img/radio_off.svg';
import Bullet from './img/bullet.svg';
import Warning from './img/warning.svg';
import Close from './img/close.svg';
import Slider from './img/slider.svg';
import Clock from './img/clock.svg';
import Card from './img/card.svg';
import Info from './img/info.svg';
import Calendar from './img/calendar.svg';
import Mail from './img/mail.svg';
import Phone from './img/phone.svg';
import Bf from './img/bf.svg';
import List from './img/list.svg';
import Picture from './img/picture.svg';
import Download from './img/download.svg';
import Slow1 from './img/Slow1.svg';
import Slow2 from './img/Slow2.svg';
import Instant1 from './img/Instant1.svg';
import Instant2 from './img/Instant2.svg';
import Pdf from './img/pdf.svg';
import { toPascalCase } from '../../../utils/utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TYPES: { [key: string]: any } = {
  Dropdown,
  CheckboxOn,
  CheckboxOff,
  Bullet,
  Warning,
  Close,
  Slider,
  RadioOn,
  RadioOff,
  Clock,
  Calendar,
  Card,
  Info,
  Mail,
  Phone,
  Bf,
  List,
  Picture,
  Download,
  Pdf,
  Slow1,
  Slow2,
  Instant1,
  Instant2
};

interface IconProps {
  id?: string;
  value: string;
  error?: boolean;
  visibility?: Visibility;
  className?: string;
  styleName?: string;
}

const Icon: React.FC<IconProps> = ({
  id,
  value,
  error = false,
  visibility = Visibility.Visible,
  className,
}) => {
  const IconComp = TYPES[toPascalCase(value)];
  return (
    <i id={id} className={className} styleName={cn('wrap')}>
      {IconComp ? (
        <IconComp
          styleName={cn('icon', {
            disabled: visibility === Visibility.Disabled,
            hidden: visibility === Visibility.Hidden,
            error,
          })}
        />
      ) : null}
    </i>
  );
};

export default Icon;
